import { render, staticRenderFns } from "./team-introduction.vue?vue&type=template&id=2c9dcf92&scoped=true&"
import script from "./team-introduction.vue?vue&type=script&lang=js&"
export * from "./team-introduction.vue?vue&type=script&lang=js&"
import style0 from "./team-introduction.vue?vue&type=style&index=0&id=2c9dcf92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9dcf92",
  null
  
)

export default component.exports